import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEvent, GridComponent, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { process } from '@progress/kendo-data-query';
import { DafService } from 'src/app/DAF/services/dafService';
import { Router, ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { EympService } from 'src/app/eymp-reverseflow/services/eympservice';
import { DatePipe } from '@angular/common';
import { ExportParams, PagingParams } from '../model/filterparams';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { CaseStepInfo } from '../model/CaseStepInfo';

@Component({
  selector: 'app-dashboard-details',
  templateUrl: './dashboard-details.component.html',
  styleUrls: ['./dashboard-details.component.scss']
})
export class DashboardDetailsComponent implements OnInit {
  @ViewChild('openDocumentInfoModalButton', { static: false }) openEditModalButton: ElementRef;
  public pageSize = 10;
  public skip = 0;
  public isPageReady = false;
  public caseList: any;
  public caseFormList: any;
  public gridViewData: any[];
  public Status = "";
  public RevFlowStatus = "";
  gridFilteredData: any;
  private notifier: NotifierService;
  public selectedcaseId = "";
  public showModel = false;
  public popupMessage;
  public isPopupalertvisible = false;
  public response;

  public gridState: DataStateChangeEvent = {

    skip: this.skip,
    take: this.pageSize
  };
  dateFilterModel: DateFiltersModel;
  fromreportDate: any;
  toreportDate: any;
  public documentInfo : CaseStepInfo[] = [];
  constructor(public _dafService: DafService, private router: Router, private route: ActivatedRoute, notifier: NotifierService, public _eympservice: EympService, public datepipe: DatePipe) {
    this.dateFilterModel = new DateFiltersModel(new Date(), new Date());
    this.notifier = notifier;
  }
  take: number;
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.RevFlowStatus = params['RevflowStatus'];
      this.Status = params['Status'];
    });
    this._dafService.currentInsDates.subscribe(data => {
      this.fromreportDate = data.fromDate;
      this.toreportDate = data.toDate;
      this.dateFilterModel = new DateFiltersModel(new Date(this.fromreportDate), new Date(this.toreportDate));
      this.refreshCaseList(this.gridState);
    });
    this.refreshCaseList(this.gridState);
  }

  onSave(action: string) {
    if (action === 'refresh') {
      this.filterCaseList(); // Refresh the grid data
    }
  }

  filterCaseList() {

    this._dafService.updateINSDate({ fromDate: this.dateFilterModel.startDate.toDateString(), toDate: this.dateFilterModel.endDate.toDateString() });
  }
  resetDashboard() {
    this._dafService.resetDate.subscribe(data => {
      this._dafService.updateINSDate({ fromDate: data, toDate: data });
    });
  }


  refreshCaseList(state: DataStateChangeEvent) {

    this.isPageReady = false;
    var kets = state;
    this.gridState = kets;
    let skip = 0;
    if (state.skip !== 0) {
      skip = state.skip / 10;
    }
    var summaryParams = new ExportParams();
    summaryParams.PagingParams = new PagingParams();
    summaryParams.PagingParams.PageNumber = skip + 1;
    summaryParams.PagingParams.PageSize = state.take;
    if (state.filter != null) {
      summaryParams.FilterParams = state.filter.filters;
    }
    else {
      summaryParams.FilterParams = null;
    }
    this._eympservice.getEympReverseflowDetailsWithStatus(this.Status, this.dateFilterModel.startDate.toDateString(), this.dateFilterModel.endDate.toDateString(), 'G', summaryParams).subscribe((data: any) => {
      this.gridFilteredData = data;
      // Binds the data to grid
      let dataParams = process(this.gridFilteredData.caseRevreseflowSummaryModel, { skip: 0, take: this.pageSize, filter: this.gridState.filter, sort: this.gridState.sort }).data;
      this.caseList = { data: dataParams, total: this.gridFilteredData.totalRowCount };
      this.isPageReady = true;

    },
      (error) => {
        this.isPageReady = true;
        //this.notifier.notify('error', 'Error occured while getting data from server');
      }
    );
  }

  exportToExcel(state: DataStateChangeEvent): Promise<any> {
    var summaryParams = new ExportParams();
    summaryParams.PagingParams = new PagingParams();
    summaryParams.PagingParams.PageNumber = 1;
    summaryParams.PagingParams.PageSize = this.caseList.total;
    if (state.filter != null) {
      summaryParams.FilterParams = state.filter.filters;
    }
    else {
      summaryParams.FilterParams = null;
    }
    this.response = this._eympservice.getEympRevflowDetInExcel(this.Status, this.dateFilterModel.startDate.toDateString(), this.dateFilterModel.endDate.toDateString(), 'E', summaryParams).subscribe((data: any) => {
      var excelDt = data.caseRevreseflowExcelModel.map(({
        insZoomCaseID, eympCaseID, clientName, caseType, caseSubType, caseSubsubType, createdDate, caseStep, caseStepCompletedDate
      }) => ({

        InsZoomCaseID: insZoomCaseID, EYMPCaseId: eympCaseID, EYMPClientName: clientName, CaseType: caseType,
        CaseSubType: caseSubType, CaseSubSubType: caseSubsubType, CreatedDate: createdDate, CaseStep: caseStep, CaseStepCompleted: caseStepCompletedDate
      }));


      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelDt);
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      let blob: any = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

      fileSaver.saveAs(blob, 'EYMPRevflowDetails.xlsx');

    },
      err => {
        this.notifier.notify('error', 'Error occured while getting data from server');
        this.isPageReady = true;
      });
    return this.response;
  }

  viewCaseStepInfo(CaseId: string, edit: boolean) {
    console.log('CaseId :'+CaseId);
    this.selectedcaseId = CaseId;
    this._eympservice.getCaseStepInfo(CaseId, this.Status, this.dateFilterModel.startDate.toDateString(), this.dateFilterModel.endDate.toDateString()).subscribe((result: CaseStepInfo[]) => {
      if (result && result.length > 0) {
        this.documentInfo = result;
        console.log(this.documentInfo);
        this.showModel = true;
        this.openEditModalButton.nativeElement.click();
      } else {
        this.confirmationDialog(true);
      }
    }, error => { console.error(error); console.log('error'); });
  }


  confirmationDialog(open: boolean) {
    this.isPageReady = false;
    
    // Opens the confirmation dialog
    if (open) {
      this.isPopupalertvisible = true;
      this.popupMessage = 'No case steps are available for the selected case in INSZoom.';
    } else {
      this.isPopupalertvisible = false;
    }
        this.isPageReady = true;      
  }

  private rowCallback(row: any) {
    const isEven = row.index % 2 == 0;
    return {
      even: isEven,
      odd: !isEven
    };
  }

}
export class DateFiltersModel {
  public startDate: Date;
  public endDate: Date;
  constructor(startDate: Date, endDate: Date) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}
